import axios, { type AxiosError, type CreateAxiosDefaults } from 'axios';
import { toast } from 'react-toastify';

import { ToastNotification } from '@/components';

export function createApiClient(serviceConfig: CreateAxiosDefaults, skipInterceptorResponse = false) {
  const apiClient = axios.create({
    ...serviceConfig,
    headers: {
      'Content-Type': 'application/json',
      ...serviceConfig.headers,
    },
  });

  if (skipInterceptorResponse) {
    return apiClient;
  }

  apiClient.interceptors.response.use(
    (response) => response.data,
    (error: AxiosError) => {
      if (error.response) {
        const { status, data } = error.response;

        switch (status) {
          case 401:
            toast(<ToastNotification type="error" title="Unauthorized! Redirecting to login..." />);
            window.location.reload();
            break;
          case 400:
            break;
          case 500:
            toast(<ToastNotification type="error" title="Internal Server Error!" />);
            break;
          default:
            toast(<ToastNotification type="error" title="Unexpected error" />);
            console.error('Unexpected error:', data);
        }
      }

      return Promise.reject(error);
    },
  );

  return apiClient;
}
